import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DAYS_OF_WEEK, WorkingDay, WorkingHour } from '../follow-up.model';

interface WorkingHoursModalData {
  allowAllHours: boolean;
  workingHours: WorkingDay[];
}

@Component({
    selector: 'app-working-hours-modal',
    templateUrl: './working-hours-modal.component.html',
    styleUrls: ['./working-hours-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkingHoursModalComponent implements OnInit {
  allowAllHours: boolean = true;
  workingHours: WorkingDay[] = [];
  daysOfWeek = DAYS_OF_WEEK;

  constructor(
    public dialogRef: MatDialogRef<WorkingHoursModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WorkingHoursModalData
  ) { }

  ngOnInit(): void {
    this.allowAllHours = this.data.allowAllHours === undefined ? true : Boolean(this.data.allowAllHours);
    
    if (this.data.workingHours && this.data.workingHours.length > 0) {
      this.workingHours = [...this.data.workingHours];
    } else {
      this.initializeDefaultWorkingHours();
    }
  }

  private initializeDefaultWorkingHours(): void {
    this.workingHours = DAYS_OF_WEEK.map(day => ({
      dayWeek: day.value,
      active: day.value <= 5,
      hours: [{ start: '08:00', end: '18:00' }]
    }));
  }

  toggleDayStatus(day: WorkingDay): void {
    day.active = !day.active;
  }

  addHourRange(day: WorkingDay): void {
    day.hours.push({ start: '08:00', end: '18:00' });
  }

  removeHourRange(day: WorkingDay, index: number): void {
    day.hours.splice(index, 1);
  }

  apply(): void {
    this.dialogRef.close({
      allowAllHours: this.allowAllHours,
      workingHours: this.allowAllHours ? [] : this.workingHours
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  getDayLabel(dayWeek: number): string {
    const day = this.daysOfWeek.find(d => d.value === dayWeek);
    return day ? day.label : 'Desconhecido';
  }

  isDayActive(dayWeek: number): boolean {
    const day = this.workingHours.find(d => d.dayWeek === dayWeek);
    return day ? day.active : false;
  }

  isValidHourRange(range: WorkingHour): boolean {
    if (!range.start || !range.end) return false;
    
    const startParts = range.start.split(':').map(Number);
    const endParts = range.end.split(':').map(Number);
    
    const startMinutes = startParts[0] * 60 + startParts[1];
    const endMinutes = endParts[0] * 60 + endParts[1];
    
    return endMinutes > startMinutes;
  }
}
